import { render, staticRenderFns } from "./PsGroupsListSearchBar.vue?vue&type=template&id=165c023a&scoped=true&"
import script from "./PsGroupsListSearchBar.vue?vue&type=script&lang=js&"
export * from "./PsGroupsListSearchBar.vue?vue&type=script&lang=js&"
import style0 from "./PsGroupsListSearchBar.vue?vue&type=style&index=0&id=165c023a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165c023a",
  null
  
)

export default component.exports